import { createRoute } from '@tanstack/react-router'
import { authLayoutRoute } from 'src/layouts/routes'

import { NotFoundPage } from '..'

export const route404 = createRoute({
  getParentRoute: () => authLayoutRoute,
  component: () => <NotFoundPage />,
  path: '/404'
})
